const ITEMS_PER_ROW = ["auto", "1", "2", "3", "4"];

export const props = Object.freeze({
  /**
   * Number of cards laid out per row above the small breakpoint. "auto" uses a CSS grid auto-fill /
   * minmax pattern keyed to --sp-comp-interactive-card-min-width; "1", "2", "3", "4" force a fixed
   * column count. On small screens the layout collapses to a single column regardless.
   *
   * @type {Number|String}
   * @storybook-control select
   * @default "auto"
   */
  itemsPerRow: {
    type: [Number, String],
    default: "auto",
    validator: (value) => ITEMS_PER_ROW.includes(String(value)),
  },
  /**
   * Label for the action button rendered in place of Next on the last card of the modal flow.
   *
   * @type {String}
   * @default undefined
   */
  finalActionLabel: {
    type: String,
    default: undefined,
  },
  /**
   * Href for the final-action button. Both label and href must be set for the button to render.
   *
   * @type {String}
   * @default undefined
   */
  finalActionHref: {
    type: String,
    default: undefined,
  },
  /**
   * Target attribute for the final-action button (e.g. "_blank" to open in a new tab).
   *
   * @type {String}
   * @default undefined
   */
  finalActionTarget: {
    type: String,
    default: undefined,
  },
});
